import { LocalDate, nativeJs } from "@js-joda/core";

//! @ngInject
export function patientPayRateResetModalCtrl(DatabaseApi, $rootScope, toaster, $scope, $uibModalInstance) {
    $scope.isSubmitting = false;

    $scope.payrollCodes = DatabaseApi.payrollCodes()
        .filter((code) => !code.nonPayable && code.isActive)
        .map((code) => ({ id: code.id, label: code.displayId }));

    $scope.rate = { payCode: {} };

    $scope.dateOptions = {
        startingDay: $rootScope.visitSettings.calendarStartDayOfTheWeek
    };

    $scope.endDatePickerOptions = {
        minDate: $scope.rate.startDate,
        startingDay: $rootScope.visitSettings.calendarStartDayOfTheWeek
    };

    $scope.payCodesMultiselectSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '250px',
        enableSearch: true,
        selectionLimit: 1,
        showUncheckAll: true,
        showCheckAll: false
    };

    $scope.cancelModal = function () {
        $uibModalInstance.dismiss('dismiss');
    };

    $scope.updateFromOptions = function () {
        $scope.endDatePickerOptions = { minDate: $scope.rate.startDate };
    };

    $scope.resetOverride = function () {
        $scope.isSubmitting = true;

        const body = {
            payCode: $scope.rate.payCode && $scope.rate.payCode.id ? $scope.rate.payCode.id : null,
            startDate: $scope.rate.startDate ? LocalDate.from(nativeJs($scope.rate.startDate)) : null,
            endDate: $scope.rate.endDate ? LocalDate.from(nativeJs($scope.rate.endDate)) : null
        };

        DatabaseApi.post(
            'agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId + '/patients/' + $scope.$resolve.patientId + '/pay_rates/reset',
            body
        ).then(function (res) {
            const count = res.data.resetCount;
            toaster.pop('success', "Pay rate overrides reset successfully", count + " override(s) reset to default");
            $uibModalInstance.close('success');
        }, function () {
            $scope.isSubmitting = false;
            toaster.pop('error', "Something went wrong", "Could not reset patient pay rate overrides");
        });
    };
}
